import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getDonXinNghi(payload: {
  page?: number;
  limit?: number;
  cond?: any;
  donViId?: string;
  startDate?: string;
  endDate?: string;
}) {
  const { page, limit, cond, donViId,startDate,endDate } = payload;
  if (donViId && donViId !== 'Tất cả') {
    return axios.get(`${ip3}/xin-nghi-hoc/pageable`, {
      params: {
        page,
        limit,
        donViId,
        cond: {
          ...cond,
          thoiGianBatDauNghiHoc: { $lte: startDate },
          thoiGianKetThucNghiHoc: { $gte: endDate },
        },
      },
    });
  }
  return axios.get(`${ip3}/xin-nghi-hoc/pageable`, {
    params: {
      page,
      limit,
      cond: {
        ...cond,
        thoiGianBatDauNghiHoc: { $lte: startDate },
        thoiGianKetThucNghiHoc: { $gte: endDate },
      },
    },
  });
}
